export const SECTIONS = {
  address: 'address',
  date: 'date',
  instructions: 'instructions',
  services: 'services',
};
